<template>
  <modal
    :is-active="true"
    :title="$t('configurator.modals.titles.upload_booth_draft')"
    @close="close">
    <template #body>
      <div class="form-horizontal">
        <div class="form-group">
          <label for="file">{{ $t('configurator.form.labels.select_file') }}:</label>
          <drop-zone @drop.prevent="drop" @change="selectedFile"></drop-zone>
          <p class="help-block mb-1 pb-1" style="font-weight: 400;">
            {{ $t('configurator.form.labels.selected_file') }}: <span v-if="dropzoneFile">{{ dropzoneFile.name }}</span>
          </p>
          <printing-information></printing-information>
          <p v-if="uploadForm.errors.has('file')" class="text-danger">
            {{ $t('configurator.form.errors.booth_draft') }}
          </p>
        </div>
        <div class="form-group text-center">
          <button type="button" class="btn btn-warning mr-2" @click.prevent="close">
            {{ $t('configurator.buttons.cancel') }}
          </button>
          <button type="button" class="btn btn-primary" @click.prevent="upload">
            {{ $t('configurator.buttons.upload') }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import {
  showErrorToast,
  showSuccessToast,
  showLoadingIndicator,
  showWarningToast
} from '@/utils/toast'
import { useMainStore } from '@/store'
import FormDataForm from '@/classes/FormDataForm'
import { computed, ref, reactive } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({ useScope: 'global' })
const store = useMainStore()
// define props
// define emits
const emit = defineEmits(['close', 'uploaded'])
// define reactive props
const dropzoneFile = ref('')
const uploadForm = reactive(new FormDataForm({
  file: null,
}))
// define computed props
const exhibition = computed(() => store.tmp.exhibition_slug)
// define methods
const close = () => emit('close')

const upload = async () => {
  showLoadingIndicator(t('configurator.indicators.upload'))
  uploadForm.file = dropzoneFile.value
  await uploadForm.post('/' + exhibition.value + '/upload')
    .then(response => {
      uploadForm.resetToOriginal()
      showSuccessToast(t('configurator.toasts.messages.booth_draft'), t('toast.title.success'))
      emit('uploaded', response.data.file)
    })
    .catch(err => {
      if (err !== undefined && err.status === 413) {
        showWarningToast(t('toast.warnings.too_large'), t('toast.title.warning'), 5000)
      } else {
        showErrorToast(t('configurator.toasts.errors.booth_draft'), t('toast.title.error'))
      }
    })
}

const drop = (e) => {
  dropzoneFile.value = e.dataTransfer.files[0]
}

const selectedFile = () => {
  dropzoneFile.value = document.getElementById('dropzoneFile').files[0]
}
</script>